module.exports = __webpack_public_path__ + "media/images/male-211bdc268d364ef48b96a6f98916f164.png";